package com.sddamico.swigmore.api

import kotlinx.serialization.json.Json

/** The wire's JSON on both sides. Unknown fields are ignored, so either side can add one first. */
val apiJson = Json { ignoreUnknownKeys = true }
